<template>
  <v-container>
    <v-container>
      <v-row>
        <v-col cols="10" >
          <p v-if="plano == 1" v-html="instrucao.textoAdministrador" ></p>
          <p  v-if="plano == 23 || plano == 24" v-html="instrucao.textoR1" ></p>
          <p  v-if="plano == 26 || plano == 27" v-html="instrucao.textoR3" ></p>
          <p  v-if="plano == 33 || plano == 34" v-html="instrucao.textoDerma" ></p>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import instrucao from  '../../components/jsonsHelper/dashboardInstructions'
export default {
  data: () => ({
    user: '',
    instrucao: instrucao, 
    plano:''
  }), 
   created() {
    this.initialize();
  }, 
  methods: {
    initialize(){
      this.user = JSON.parse(localStorage.getItem('auth.currentUser'))
      this.plano = this.user.assinaturasList[0]?.plano?.idPlano
    }
  }
}
</script>
